{
  "version": 1,
  "asset_id": "53a6ad09-3c50-4f4f-acf2-aa0927929c1b",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/53a6ad09-3c50-4f4f-acf2-aa0927929c1b/egg-frozen.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/53a6ad09-3c50-4f4f-acf2-aa0927929c1b/egg-frozen.webp",
  "original_filename": "egg-frozen.webp",
  "size": 6376,
  "content_type": "image/webp",
  "created_at": "2026-08-06T21:54:13Z"
}
